import 'slick-carousel';

const carouselScripts = () => {
    // Fund carousel block insiide `Find Your Investment Solution`
    $('.fund-carousel-block__main--desktop').each(function (id) {
        const slider = $(this);
        this.id = `fund-carousel-block-${id}`;

        /*
         * Count calc for Fund Carousel's now driven from overrides
         * Refer override/education.js
         */
        //slider.on('init reInit afterChange', function(_, slick, currentSlide) {
        //  const currentSlideNumber = currentSlide ? currentSlide : 0;
        //  const i = currentSlideNumber + 1;
        //  const slidesToShow = slick.options.slidesToShow;
        //  const el = $(`#fund-carousel-block-${id}`).prev().find(`.fund-carousel-block__main--desktop-count`);
        //  if (slidesToShow > 1) {
        //    el.html(`<b>${i}</b> - <b>${currentSlideNumber + slidesToShow}</b> of <span>${slick.slideCount}</span>`);
        //  }
        //  else {
        //    el.html(`<b>${i}</b> of <span>${slick.slideCount}</span>`);
        //  }
        //});

        $('.fund-carousel-block__main--desktop.d-none.delayed-carousel').removeClass("d-none");

        slider.slick({
            rows: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            appendArrows: $('.fund-carousel-block__control-container')[id],
            prevArrow: `
        <button class="fund-carousel-block__control fund-carousel-block__control--prev" type="button" aria-label="Scroll left">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-left"
            class="svg-inline--fa fa-chevron-left fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M13.13 2.26a.75.75 0 00-.22-.54.75.75 0 00-1.07 0L5.1 8.47a.75.75 0 000 1.06l6.75 6.75a.75.75 0 001.07 0 .75.75 0 000-1.06L6.69 9l6.22-6.22a.75.75 0 00.21-.52z"
            >
            </path>
          </svg>
        </button>
      `,
            nextArrow: `
        <button class="fund-carousel-block__control fund-carousel-block__control--next" type="button" aria-label="Scroll right">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-right"
            class="svg-inline--fa fa-chevron-right fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M4.87 15.74a.75.75 0 00.22.54.75.75 0 001.07 0l6.75-6.75a.75.75 0 000-1.06L6.16 1.72a.75.75 0 00-1.07 0 .75.75 0 000 1.06L11.31 9 5.1 15.22a.75.75 0 00-.22.52z"
            >
            </path>
          </svg>
        </button>
      `,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        });
    });

    if (screen.orientation) {
        screen.orientation.addEventListener("change", (event) => {
            if ($('.slider-for').length) $('.slider-for')[0].slick.refresh();
        });
    }

    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        arrows: false,
        dots: true,
        draggable: false,
        swipe: false,
        appendDots: '.compound-hero__slick-dots',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    draggable: true,
                    swipe: true,
                },
            },
        ],
    });

    /* eslint-disable max-len */
    $('.recommended-insights__list').each(function (id) {
        const slider = $(this);
        this.id = `recommended-insights-list-${id}`;

        const actions = $(`.recommended-insights__actions-${id}`);
        const counts = actions.find('.recommended-insights__counts');
        const arrows = actions.find('.recommended-insights__arrows');

        if (id === 0) actions.css('display', 'block');
        else actions.css('display', 'none');

        slider.on('init reInit afterChange', function (_, slick, currentSlide) {
            const currentSlideNumber = currentSlide ? currentSlide : 0;
            const i = currentSlideNumber + 1;
            const slidesToShow = slick.options.slidesToShow;
            if (slidesToShow > 1) {
                counts.html(`<b>${i}</b> - <b>${currentSlideNumber + slidesToShow}</b> of <span>${slick.slideCount}</span>`);
            }
            else {
                counts.html(`<b>${i}</b> of <span>${slick.slideCount}</span>`);
            }
        });

        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: "ondemand",
            infinite: false,
            arrows: true,
            appendArrows: arrows,
            prevArrow: `
      <button class="recommended-insights__carousel-control recommended-insights__carousel-control--prev" type="button" aria-label="Scroll left">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="far"
          data-icon="chevron-left"
          class="svg-inline--fa fa-chevron-left fa-w-16 fa-lg icon"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
        >
          <path
            fill="currentColor"
            d="M13.13 2.26a.75.75 0 00-.22-.54.75.75 0 00-1.07 0L5.1 8.47a.75.75 0 000 1.06l6.75 6.75a.75.75 0 001.07 0 .75.75 0 000-1.06L6.69 9l6.22-6.22a.75.75 0 00.21-.52z"
          >
          </path>
        </svg>
      </button>
    `,
            nextArrow: `
      <button class="recommended-insights__carousel-control recommended-insights__carousel-control--next" type="button" aria-label="Scroll right">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="far"
          data-icon="chevron-right"
          class="svg-inline--fa fa-chevron-right fa-w-16 fa-lg icon"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
        >
          <path
            fill="currentColor"
            d="M4.87 15.74a.75.75 0 00.22.54.75.75 0 001.07 0l6.75-6.75a.75.75 0 000-1.06L6.16 1.72a.75.75 0 00-1.07 0 .75.75 0 000 1.06L11.31 9 5.1 15.22a.75.75 0 00-.22.52z"
          >
          </path>
        </svg>
      </button>
    `,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    });

    //
    $('.carousel-block__main--desktop').each(function (id) {
        const slider = $(this);
        this.id = `carousel-block-${id}`;

        slider.on('init reInit afterChange', function (_, slick, currentSlide) {
            const currentSlideNumber = currentSlide ? currentSlide : 0;
            const i = currentSlideNumber + 1;
            const slidesToShow = slick.options.slidesToShow;
            const el = $(`#carousel-block-${id}`).prev().find(`.carousel-block__main--desktop-count`);
            if (slidesToShow > 1) {
                el.html(`<b>${i}</b> - <b>${currentSlideNumber + slidesToShow}</b> of <span>${slick.slideCount}</span>`);
            }
            else {
                el.html(`<b>${i}</b> of <span>${slick.slideCount}</span>`);
            }

            // check to see if there are one or less slides
            if (slick.slideCount < slidesToShow) {
                slider.find('.slick-dots').hide();
            }
        });
        slider.removeClass("d-none");
        slider.slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            arrows: true,
            dots: true,
            appendArrows: $('.carousel-block__control-container')[id],
            prevArrow: `
        <button class="carousel-block__control carousel-block__control--prev" type="button" aria-label="Scroll left">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-left"
            class="svg-inline--fa fa-chevron-left fa-w-16 fa-3x icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M13.13 2.26a.75.75 0 00-.22-.54.75.75 0 00-1.07 0L5.1 8.47a.75.75 0 000 1.06l6.75 6.75a.75.75 0 001.07 0 .75.75 0 000-1.06L6.69 9l6.22-6.22a.75.75 0 00.21-.52z"
            >
            </path>
          </svg>
        </button>
      `,
            nextArrow: `
        <button class="carousel-block__control carousel-block__control--next" type="button" aria-label="Scroll right">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-right"
            class="svg-inline--fa fa-chevron-right fa-w-16 fa-3x icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M4.87 15.74a.75.75 0 00.22.54.75.75 0 001.07 0l6.75-6.75a.75.75 0 000-1.06L6.16 1.72a.75.75 0 00-1.07 0 .75.75 0 000 1.06L11.31 9 5.1 15.22a.75.75 0 00-.22.52z"
            >
            </path>
          </svg>
        </button>
      `,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        });
    });

    $('.carousel-wrapper__main--desktop').each(function (id) {
        const slider = $(this);
        this.id = `carousel-wrapper-${id}`;

        slider.on('init reInit afterChange', function (_, slick, currentSlide) {
            const currentSlideNumber = currentSlide ? currentSlide : 0;
            const i = currentSlideNumber + 1;
            const slidesToShow = slick.options.slidesToShow;
            var carousel = $(`#carousel-wrapper-${id}`).prev();
            const el = carousel.find(`.carousel-wrapper__main--desktop-count`);
            if (slidesToShow > 1 && slick.slideCount > 1 && slidesToShow > slick.slideCount) {
                el.html(`<b>${i}</b> - <b>${currentSlideNumber + slick.slideCount}</b> of <span>${slick.slideCount}</span>`);
            }
            else if (slidesToShow > 1 && slick.slideCount > 1) {
                el.html(`<b>${i}</b> - <b>${currentSlideNumber + slidesToShow}</b> of <span>${slick.slideCount}</span>`);
            }
            else {
                el.html(`<b>${i}</b> of <span>${slick.slideCount}</span>`);
            }
            carousel.find("button.carousel-wrapper__control[aria-disabled='false']").attr("data-ve-gtm", "arrow-more");
            carousel.find("button.carousel-wrapper__control[aria-disabled='true']").removeAttr("data-ve-gtm");
        });

        $('.carousel-wrapper__main--desktop.d-none.delayed-carousel').removeClass("d-none");
        slider.slick({
            rows: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            appendArrows: $('.carousel-wrapper__control-container')[id],
            prevArrow: `
        <button class="carousel-wrapper__control carousel-wrapper__control--prev" type="button" aria-label="Scroll left">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-left"
            class="svg-inline--fa fa-chevron-left fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M13.13 2.26a.75.75 0 00-.22-.54.75.75 0 00-1.07 0L5.1 8.47a.75.75 0 000 1.06l6.75 6.75a.75.75 0 001.07 0 .75.75 0 000-1.06L6.69 9l6.22-6.22a.75.75 0 00.21-.52z"
            >
            </path>
          </svg>
        </button>
      `,
            nextArrow: `
        <button class="carousel-wrapper__control carousel-wrapper__control--next" type="button" aria-label="Scroll right">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-right"
            class="svg-inline--fa fa-chevron-right fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M4.87 15.74a.75.75 0 00.22.54.75.75 0 001.07 0l6.75-6.75a.75.75 0 000-1.06L6.16 1.72a.75.75 0 00-1.07 0 .75.75 0 000 1.06L11.31 9 5.1 15.22a.75.75 0 00-.22.52z"
            >
            </path>
          </svg>
        </button>
      `,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    });

    $('.more-from-category__main--desktop').each(function (id) {
        const slider = $(this);
        this.id = `more-from-category-${id}`;

        slider.on('init reInit afterChange', function (_, slick, currentSlide) {
            const currentSlideNumber = currentSlide ? currentSlide : 0;
            const i = currentSlideNumber + 1;
            const slidesToShow = slick.options.slidesToShow;
            var carousel = $(`#more-from-category-${id}`).prev();
            const el = carousel.find(`.more-from-category__main--desktop-count`);
            if (slidesToShow > 1 && slick.slideCount > 1 && slidesToShow > slick.slideCount) {
                el.html(`<b>${i}</b> - <b>${currentSlideNumber + slick.slideCount}</b> of <span>${slick.slideCount}</span>`);
            }
            else if (slidesToShow > 1 && slick.slideCount > 1) {
                el.html(`<b>${i}</b> - <b>${currentSlideNumber + slidesToShow}</b> of <span>${slick.slideCount}</span>`);
            }
            else {
                el.html(`<b>${i}</b> of <span>${slick.slideCount}</span>`);
            }
            carousel.find("button.more-from-category__control[aria-disabled='false']").attr("data-ve-gtm", "arrow-more");
            carousel.find("button.more-from-category__control[aria-disabled='true']").removeAttr("data-ve-gtm");
        });

        $('.more-from-category__main--desktop.d-none.delayed-carousel').removeClass("d-none");
        slider.slick({
            rows: 0,
            slidesToShow: 1,
            accessibility: false,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            arrows: false,
            appendArrows: $('.more-from-category__control-container')[id],
            prevArrow: `
        <button class="more-from-category__control more-from-category__control--prev" type="button" aria-label="Scroll left">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-left"
            class="svg-inline--fa fa-chevron-left fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M13.13 2.26a.75.75 0 00-.22-.54.75.75 0 00-1.07 0L5.1 8.47a.75.75 0 000 1.06l6.75 6.75a.75.75 0 001.07 0 .75.75 0 000-1.06L6.69 9l6.22-6.22a.75.75 0 00.21-.52z"
            >
            </path>
          </svg>
        </button>
      `,
            nextArrow: `
        <button class="more-from-category__control more-from-category__control--next" type="button" aria-label="Scroll right">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-right"
            class="svg-inline--fa fa-chevron-right fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M4.87 15.74a.75.75 0 00.22.54.75.75 0 001.07 0l6.75-6.75a.75.75 0 000-1.06L6.16 1.72a.75.75 0 00-1.07 0 .75.75 0 000 1.06L11.31 9 5.1 15.22a.75.75 0 00-.22.52z"
            >
            </path>
          </svg>
        </button>
      `,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
            ],
        });
    });

    $('.latest-digital-grid__main--desktop').each(function (id) {
        const slider = $(this);
        this.id = `latest-digital-grid-${id}`;

        slider.on('init reInit afterChange', function (_, slick, currentSlide) {
            const currentSlideNumber = currentSlide ? currentSlide : 0;
            const i = currentSlideNumber + 1;
            const slidesToShow = slick.options.slidesToShow;
            var carousel = $(`#latest-digital-grid-${id}`).prev();
            const el = carousel.find(`.latest-digital-grid__main--desktop-count`);
            if (slidesToShow > 1) {
                el.html(`<b>${i}</b> - <b>${currentSlideNumber + slidesToShow}</b> of <span>${slick.slideCount}</span>`);
            }
            else {
                el.html(`<b>${i}</b> of <span>${slick.slideCount}</span>`);
            }
            carousel.find("button.latest-digital-grid__control[aria-disabled='false']").attr("data-ve-gtm", "arrow-more");
            carousel.find("button.latest-digital-grid__control[aria-disabled='true']").removeAttr("data-ve-gtm");
        });

        slider.slick({
            slidesToShow: 1,
            rows: 0,
            accessibility: false,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            arrows: false,
            appendArrows: $('.latest-digital-grid__control-container')[id],
            prevArrow: `
        <button class="latest-digital-grid__control latest-digital-grid__control--prev" type="button" aria-label="Scroll left">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-left"
            class="svg-inline--fa fa-chevron-left fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M13.13 2.26a.75.75 0 00-.22-.54.75.75 0 00-1.07 0L5.1 8.47a.75.75 0 000 1.06l6.75 6.75a.75.75 0 001.07 0 .75.75 0 000-1.06L6.69 9l6.22-6.22a.75.75 0 00.21-.52z"
            >
            </path>
          </svg>
        </button>
      `,
            nextArrow: `
        <button class="latest-digital-grid__control latest-digital-grid__control--next" type="button" aria-label="Scroll right">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-right"
            class="svg-inline--fa fa-chevron-right fa-w-16 fa-lg icon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="currentColor"
              d="M4.87 15.74a.75.75 0 00.22.54.75.75 0 001.07 0l6.75-6.75a.75.75 0 000-1.06L6.16 1.72a.75.75 0 00-1.07 0 .75.75 0 000 1.06L11.31 9 5.1 15.22a.75.75 0 00-.22.52z"
            >
            </path>
          </svg>
        </button>
      `,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                    },
                },
            ],
        });
    });

  $(".bau-carousel-hero").slick({
    slidesToShow: 1,
    rows: 0,
    appendDots: ".bau-carousel-navigation",
    accessibility: false,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    arrows: false,
    draggable: true,
    dots: true,
    mobileFirst: true,
    variableWidth: true,
    touchThreshold: 5,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
          variableWidth: true,
          dots: false,
          touchThreshold: 20,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          variableWidth: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          variableWidth: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          dots: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });

  (function initBundledSlider() {
    const slider = document.querySelector(".bundled-content-slider-wrapper");
    if (!slider) return;
    const sliderInner = document.querySelector(".bundled-content-slider");
    const slideInners = document.querySelectorAll(
      ".bundled-content-slider-item-inner"
    );
    const sliderInnerMap = {};
    slideInners.forEach((slideInner, index) => {
      const { image, mobileImage, tabletImage, video, mobileVideo, poster, imageAlt } = slideInner.dataset;
      const standalone = slideInner.querySelector(".hidden-js-standalone");
      sliderInnerMap[index] = {
        image,
        mobileImage,
        tabletImage,
        video,
        standalone,
        mobileVideo, 
        poster,
        imageAlt
      };
    });

    const standaloneContainer = slider.querySelector('.bundled-content-slider-standalone-container');
    const initialStandalone = standaloneContainer.querySelector('.initial-standalone-content')

    const hasElement = (slideIndex, key) => !!sliderInnerMap[slideIndex]?.[key];
    const generateHero = (index) => {
      const slide = sliderInnerMap[index];
      const hasVideo = hasElement(index, "video");
      const hasImage = hasElement(index, "image");
      const hasStandalone = hasElement(index, 'standalone')
      const sliderImageContainer = slider.querySelector(
        ".bundled-content-slider-wrapper-image-container"
      );
      const sliderVideoContainer = slider.querySelector("#video-banner-home");
      const sliderNoMediaContainer = slider.querySelector(".compound-hero__bg");
      const component =
        sliderVideoContainer || sliderImageContainer || sliderNoMediaContainer;
      let newMarkup = "";

      if (component) {
        component.style.transition = `opacity ${sliderInner.dataset.fade}ms ease`;
        component.style.opacity = "0";

        component.addEventListener("transitionend", () => component.remove(), {
          once: true,
        });
      }

      const standaloneSlideItem = standaloneContainer.querySelector('.hidden-js-standalone')
      if (standaloneSlideItem) {
        standaloneSlideItem.remove()
      }

      if (hasStandalone) {
        initialStandalone.style.display = 'none';
        standaloneContainer.append(slide.standalone)
        
      } else {
        initialStandalone.style.display = 'block';
      }

      // switchStandaloneContent(slide.standalone)

      if (hasVideo) {
        newMarkup = `<video muted="muted" loop="loop" class="hero__bg bundled-content-slider-video-hero" preload="none" playsinline="playsinline" autoplay>
              <source id="video-banner" src="${slide.mobileVideo}" type="video/mp4" media="(max-width: 768px)">
              <source id="video-banner" src="${slide.video}" type="video/mp4" media="(min-width: 769px)">
          </video>`;
      } else if (hasImage) {
        newMarkup = `
          <picture class="bundled-content-slider-wrapper-image-container">
            <source media="(min-width:769px)" srcset="${slide.image}" />
            <source media="(min-width:426px)" srcset="${slide.tabletImage}" />
            <source media="(max-width:425px)" srcset="${slide.mobileImage}" />
            <img class="bundled-content-slider-wrapper-image" 
                src="${slide.image}" 
                alt="${slide.imageAlt ? slide.imageAlt : "hero slide"}" />
          </picture>`;
      }

      if (!hasVideo && !hasImage) {
        newMarkup = `<div class="compound-hero__bg compound-hero__bg--overlay bundled-content-slider-bg" style="background-image:url(/Static/us/images/home/hero-overlay.svg)"></div>`;
      }

      slider.insertAdjacentHTML("afterbegin", newMarkup);
      const newEl = slider.firstElementChild;
      newEl.style.opacity = "0";
      newEl.style.transition = `opacity ${sliderInner.dataset.fade}ms ease`;

      // Force reflow and fade in
      requestAnimationFrame(() => {
        newEl.style.opacity = "1";
      });
    };

    generateHero(0);

    $(".bundled-content-slider").each(function () {
      const $slider = $(this);
      const $dotsNavDesktop = $slider
        .closest(".bundled-content-slider-wrapper")
        .find(".bundled-content-slider-navigation--desktop");
      let autoplayEnabled = true;
      let $navSlider = null;
      let isMobileNavInit = false;
      const mobileBreakpoint = 768;

      // --- PROGRESS BAR LOGIC ---
      const progressNav = {
        getContainer() {
          return window.innerWidth >= mobileBreakpoint
            ? document.querySelector(
                ".bundled-content-slider-navigation--desktop"
              )
            : document.querySelector(
                ".bundled-content-slider-navigation--mobile .slick-dots"
              );
        },
        animate() {
          const container = this.getContainer();
          const activeBar = container?.querySelector(
            ".slick-active .bundled-content-slider-navigation__progress-fg"
          );
          if (activeBar) {
            activeBar.style.animation = `draw ${$slider.data(
              "speed"
            )}ms ease-out forwards`;
          }
        },
        resetAll() {
          const container = this.getContainer();
          container
            ?.querySelectorAll(
              ".bundled-content-slider-navigation__progress-fg"
            )
            .forEach((bar) => {
              bar.style.animation = "none";
            });
        },
        removeAllAnimations() {
          const container = this.getContainer();
          container
            ?.querySelectorAll(
              ".bundled-content-slider-navigation__progress-fg"
            )
            .forEach((bar) => {
              bar.style.animation = "none";
              bar.style.strokeDashoffset = 0;
            });
        },
        restart() {
          const container = this.getContainer();
          this.resetAll();
          container?.offsetHeight; // reflow
          this.animate();
        },
      };

      const disableAnimations = () => {
        autoplayEnabled = false;
        $slider.slick("slickSetOption", "autoplay", false, true);
        progressNav.removeAllAnimations();
      };

      // --- MOBILE NAV ---
      const appendMobileDots = (slides) => {
        const markup = slides
          .map((index, slide) => {
            const title = slide.dataset.title || "";
            return `
            <li class="slick-slide ${index === 0 ? "slick-active" : ""}">
              <button class="bundled-content-slider-custom-nav" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="214" height="4">
                  <path class="bundled-content-slider-navigation__progress-bg" d="M2 2H212" stroke="currentColor" stroke-width="4"/>
                  <path class="bundled-content-slider-navigation__progress-fg" d="M2 2H212" stroke="#0dd7e7" stroke-width="4" style="animation-delay:${$slider.data(
                    "speed"
                  )}ms"/>
                </svg>
                <span class="bundled-content-slider-custom-nav__text">${title}</span>
              </button>
            </li>
          `;
          })
          .get()
          .join("");

        $(".bundled-content-slider-navigation--mobile").html(
          `<ul class="slick-dots slick-slider">${markup}</ul>`
        );
      };

      const initMobileNav = () => {
        if (isMobileNavInit) return;
        $navSlider = $(
          ".bundled-content-slider-navigation--mobile .slick-dots"
        ).slick({
          arrows: false,
          dots: false,
          slidesToShow: 1,
          variableWidth: true,
          infinite: false,
          accessibility: false,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1399,
              settings: {
                slidesToShow: 3,
                variableWidth: true,
                dots: false,
                touchThreshold: 20,
              },
            },
            {
              breakpoint: 1199,
              settings: { slidesToShow: 3, variableWidth: false },
            },
          ],
        });

        $navSlider.on("click", ".slick-slide", function () {
          const index = $(this).data("slick-index");
          if (typeof index !== "undefined") {
            $slider.slick("slickGoTo", index);
            $navSlider.slick("slickGoTo", index);
          }
        });

        $navSlider.on("afterChange", (e, slick, current) => {
          $slider.slick("slickGoTo", current);
        });

        $navSlider.on("swipe", disableAnimations);

        isMobileNavInit = true;
      };

      const destroyMobileNav = () => {
        if (!isMobileNavInit) return;
        $navSlider?.slick("unslick");
        isMobileNavInit = false;
        $navSlider = null;
      };

      // --- SLIDER INIT ---
      $slider.on("init", function (event, slick) {
        if (window.innerWidth < mobileBreakpoint) {
          appendMobileDots(slick.$slides);
          initMobileNav();
        }
        progressNav.animate();
      });

      $slider.on('beforeChange', (e,slick,current, next) => {
        const video = document.querySelector('.bundled-content-slider-standalone-container video')
        video?.pause();
        generateHero(next);
      })

      $slider.on("afterChange", (e, slick, current) => {
        if (isMobileNavInit && autoplayEnabled) {
          $navSlider.slick("slickGoTo", current);
        }

        // generateHero(current);

        if (autoplayEnabled) {
          progressNav.restart();
        }
      });

      $slider.slick({
        slidesToShow: 1,
        rows: 0,
        accessibility: false,
        dots: true,
        fade: true,
        speed: $slider.data("fade"),
        cssEase: "linear",
        autoplaySpeed: $slider.data("speed"),
        arrows: false,
        appendDots: $dotsNavDesktop,
        infinite: true,
        lazyLoad: true,
        autoplay: true,
        swipe: false,
        customPaging: (slider, i) => {
          const title = slider.$slides.eq(i).data("title") || "";
          return `
            <button class="bundled-content-slider-custom-nav">
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 196 6" fill="none">
                <path class="bundled-content-slider-navigation__progress-bg" d="M3 3H193" stroke-width="6" stroke-linecap="round"/>
                <path class="bundled-content-slider-navigation__progress-fg" stroke="#0dd7e7" style="animation-delay: ${$slider.data(
                  "speed"
                )}ms" d="M3 3H193" stroke-width="6" stroke-linecap="round"/>
              </svg>
              <span class="bundled-content-slider-custom-nav__text">${title}</span>
            </button>
          `;
        },
      });

      // --- DOT CLICK HANDLER (desktop or mobile) ---
      $(document).on(
        "click",
        ".bundled-content-slider-custom-nav",
        disableAnimations
      );

      // --- RESIZE ---
      // Function to handle width change
      function handleResize() {
        if (window.innerWidth < mobileBreakpoint) {
          if (!isMobileNavInit) {
            appendMobileDots($slider.slick("getSlick").$slides);
            initMobileNav();
          }
        } else {
          if (isMobileNavInit) {
            destroyMobileNav();
          }
        }
      }

      window.addEventListener("resize", handleResize);
    });
  })();
}

carouselScripts();